type DownloadForm = { url: string | undefined; title: string };

export const useDownload = () => {
  const downloadInternal = async (url: string, title: string) => {
    const a = document.createElement("a");
    a.href = url;
    a.setAttribute("download", title);
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  };

  const downloadLocal = async (url: string, title: string) => {
    await downloadInternal(url, title);
  };

  const download = async (url: string, title: string) => {
    const response = await fetch(`/api/download?url=${url}`);
    await downloadInternal(response.url, title);
  };

  const downloadMultiple = async (downloadData: DownloadForm[]) => {
    await Promise.all(
      downloadData.map(async ({ url, title }) => {
        if (url) {
          await download(url, title);
        }
      }),
    );
  };

  return {
    download,
    downloadLocal,
    downloadMultiple,
  };
};
